<div class="contact-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Have Questions?</span>
            <h2>Drop Us a Line</h2>
            <p>We would love to hear from you! Reach out to us for inquiries, partnership opportunities, or any
                questions you may have about the RoundtableCxO.</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-12">
                <div class="contact-form">
                    <form id="contactForm">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="name" id="name" class="form-control" required
                                        data-error="Please enter your name" placeholder="">
                                        <label for="fname" class="form-label">Your Name <sup>*</sup> </label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="email" name="email" id="email" class="form-control" required
                                        data-error="Please enter your email" placeholder="">
                                        <label for="fname" class="form-label">Your Email <sup>*</sup> </label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <!-- <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <input type="text" name="phone_number" id="phone_number" required data-error="Please enter your number" class="form-control" placeholder="Phone Number">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control" required data-error="Please enter your subject" placeholder="Subject">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div> -->
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control" required
                                        data-error="Company" placeholder="">
                                        <label for="fname" class="form-label">Company</label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control" required
                                        data-error="Title" placeholder="">
                                        <label for="fname" class="form-label">Title  </label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>
                           
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group has-float-label">
                                    <input type="text" name="msg_subject" id="msg_subject" class="form-control" required
                                        data-error="Which market " placeholder=" ">
                                        <label for="fname" class="form-label">Which Market</label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group has-float-label">
                                    <textarea name="message" class="form-control" id="message" cols="30" rows="5"
                                        required data-error="Write your message" placeholder=""></textarea>
                                        <label for="fname" class="form-label">Your Message</label>

                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn"> Send Message <span></span></button>
                                <div id="msgSubmit" class="h3 text-center hidden"></div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <ul class="contact-address">
                    <li>
                        <i class='bx bx-envelope'></i>
                        <h4>Let’s Call or Email</h4>
                        <a href=""><span class="__cf_email__">support&#64;roundtablecxo.com</span></a>
                        <a href="">+1 234 567 8967</a>
                    </li>

                    <li>
                        <i class='bx bx-user'></i>
                        <h4>Our Support Team</h4>
                        <a href=""><span class="__cf_email__">support&#64;roundtablecxo.com</span></a>
                        <a href="">+1 234 567 8967</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>